import type { StoreConfig } from "@jti/store/slices/magentoApiSlice";
import type { GetProfileQueryData } from "@jti/store/slices/profileApiSlice";
import type { Translate } from "@jti/ui";

import type { FormFieldConfig, FormFieldFactory } from "@checkout-v2/formFields";

export type LastNameFieldConfig = FormFieldConfig<"lastName"> & {
  savedDefaultValue: string;
};

export type LastNameFieldConfigArgs = {
  storeConfig: StoreConfig;
  profile: GetProfileQueryData;
  __: Translate;
};

export type LastNameGetDefaultValueArgs = {
  profile: GetProfileQueryData;
};

export const lastNameFieldFactory: FormFieldFactory<
  "lastName",
  string,
  [LastNameFieldConfigArgs],
  [LastNameGetDefaultValueArgs],
  LastNameFieldConfig
> = {
  getDerivedConfig: ({ __, storeConfig, profile }) => {
    const label = storeConfig?.allowEmptyFirstname ? __("contact_info.name") : __("contact_info.lastname");

    return {
      name: "lastName",
      label,
      placeholder: label,
      registerOptions: { required: true, disabled: false },
      savedDefaultValue: lastNameFieldFactory.getDefaultValue({ profile }),
    };
  },
  getDefaultValue: ({ profile }) => {
    return profile.personalInfo.lastname || "";
  },
};
